<template>
  <div class="congratulations-container" role="presentation">
    <header-mobile></header-mobile>
    <div class="congratulations-image" v-bind:style="{backgroundImage: 'url(' + stng.header_image + ')'}" role="presentation"></div>
    <main class="content" aria-label="Main content">
      <h1 class="main-color">{{ $t('message.congratulations') }}!</h1>
      <p v-html="$tr(stng.text)"></p>
      <a :href="stng.cta_buttons.button_1.href" target="_blank" class="btn cta-btn main-background secondary-text">{{ $tr(stng.cta_buttons.button_1.name) }}</a>
      <a :href="stng.cta_buttons.button_2.href" target="_blank" class="btn cta-btn main-background secondary-text">{{ $tr(stng.cta_buttons.button_2.name) }}</a>
      <a :href="stng.cta_buttons.button_3.href" target="_blank" class="btn cta-btn main-background secondary-text">{{ $tr(stng.cta_buttons.button_3.name) }}</a>
    </main>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import HeaderMobile from '@/components/HeaderMobile'

export default {
  name: 'Notes',
  components: {
    'header-mobile': HeaderMobile
  },
  computed: {
    ...mapState({
      stng: state => state.college.settings.congrats_page,
      menu_links: state => state.college.settings.menu_links
    })
  }
}
</script>
